const r = ["application/problem+json", "application/json"], p = async (t, e, o = { "Content-Type": "application/json" }) => fetch(t, {
  method: "POST",
  body: e,
  headers: o
}).then((c) => s(c)), i = async (t, e = { "Content-Type": "application/json" }) => fetch(t, {
  method: "GET",
  headers: e
}).then((n) => s(n)), h = async (t, e = { "Content-Type": "application/json" }) => fetch(t, {
  method: "DELETE",
  headers: e
}).then((n) => s(n)), s = async (t) => {
  if (t.status === 200) {
    const a = t.headers.get("content-type");
    return a && a.indexOf("application/json") > -1 ? t.json() : t.text();
  }
  let e, o;
  const n = t.headers.get("content-type");
  throw n && r.includes(n) ? e = await t.json() : o = await t.text(), {
    status: t.status,
    statusText: t.statusText,
    errorObject: e,
    errorText: o
  };
};
export {
  h as deleteFetch,
  i as getFetch,
  p as postFetch
};
